import { keepPreviousData } from '@tanstack/react-query';
import useReactQueryTypeahead from 'components/Inputs/Select/useReactQueryTypeahead';
import { TEAM_MEMBERS } from 'queries/query-keys';
import { getTeamLabel } from 'services/helpers';
import TeamMemberService from 'services/TeamMemberService';
import LoadingMessage from './components/LoadingMessage';

const convertOption = (option) => {
  const label = getTeamLabel(option);
  return {
    value: option.id,
    label,
    data: {
      ...option,
      displayName: label,
    },
  };
};

const fetchData = async (search, pageSize, orderBy = 'first_name') => {
  const res = await TeamMemberService.getTeamMemberTypeahead({
    search,
    ordering: orderBy,
    page_size: pageSize,
  });
  if (res.results) {
    return res;
  }
  return { results: res };
};

const useTeamMemberTypeahead = (onResultsChange, options = {}) => {
  const {
    debouncePeriod = 150,
    pageSize = 50,
    filterOption = () => true,
    enabled = true,
  } = options;
  const { selectProps } = useReactQueryTypeahead(
    ({ search }) => fetchData(search, pageSize), // fetch function
    TEAM_MEMBERS.TYPEAHEAD_LIST(false), // query key
    {
      optionMapper: convertOption,
      onResultsChange,
      placeholderData: keepPreviousData,
      enabled,
    }, // config
    [pageSize], // dependencies (auto-injected to query key)
    debouncePeriod
  );

  return {
    ...selectProps,
    classNamePrefix: 'team-member-typeahead',
    components: {
      LoadingMessage,
      LoadingIndicator: null,
    },
    menuTopButton: null,
    filterOption,
  };
};

export default useTeamMemberTypeahead;
